import * as React from "react";
const SvgFiBrandsKickstarter = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="m19.532 12.006 2.273-2.168a5.58 5.58 0 0 0 0-8.148c-2.355-2.245-6.19-2.245-8.544 0l-.829.789C11.338.978 9.53 0 7.467 0 4.133 0 1.428 2.579 1.428 5.758v12.484C1.428 21.421 4.133 24 7.467 24c2.063 0 3.87-.978 4.965-2.479l.829.789c2.355 2.245 6.19 2.245 8.544 0a5.58 5.58 0 0 0 0-8.148z"
    />
  </svg>
);
export default SvgFiBrandsKickstarter;
